import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterModule } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';

@Component({
  selector: 'app-booking-form-type01',
  standalone: true,
  imports: [MatIconModule, RouterModule, RouterLink, FormsModule, NgClass],
  templateUrl: './booking-form-type01.component.html',
  styleUrl: './booking-form-type01.component.scss'
})
export class BookingFormType01Component implements OnInit {

  public view: any = {
    bookingForm: {
      personRequesting: '',
      mainTravellerPosition: '',
      additionalPersonOnePosition: '',
      additionalPersonTwoPosition: '',
      roomType: '',
      numberOfRooms: ''
    }
  }

  constructor(public _tfmService: TFMService, private _cd: ChangeDetectorRef) {

    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
    });

    this._tfmService.getDestinations().then(res => {
      this.view.destinations = res;
      this._tfmService.log('Get Destinations: ', res);
    });

    this._tfmService.getPages().then((res: any) => {
      this.view.pages = res.content.filter(x => !(x.section === 'about' || x.section === 'contact' || x.section === 'xl-howzit-promo' || x.section === 'corporate-travel' || x.section === 'leisure-travel' || x.section === 'team' || x.section === 'non-profit' || x.section === 'events'));
      // this.view.pages = res;
      // this._tfmService.log(res);
    });
  }

  RoomTypes = [
    { room: 'Single'},
    { room: 'Double Sharing'},
    { room: 'Double Sharing'},
    { room: 'Twin Sharing'},
    { room: 'Triple Sharing - 3 Beds or 2 Beds (Double and Single)'},
    { room: 'Quad Sharing - 4 Beds or 2 Beds (Double Beds)'},
    { room: 'Inter-Leading Rooms'},
    { room: 'Inter-Leading Rooms'},
    { room: '1 Bedroom Self Catering'},
    { room: '2 Bedroom Self Catering'},
    { room: '3 Bedroom Self Catering'},
    { room: '4 Bedroom Self Catering'},
    { room: 'Other'},
    { room: 'S&T'},
  ]

  numberOfRooms = [
    {number: 1},
    {number: 2},
    {number: 3},
    {number: 4},
    {number: 5},
    {number: 6},
    {number: 7},
    {number: 8},
    {number: 9},
    {number: '10 or more'}
  ]

  mainTravellers = [
    { position: 'Divisional Sales Manager' },
    { position: 'Executive: Operations' },
    { position: 'Financial Director' },
    { position: 'Financial Manager' },
    { position: 'HR Manager' },
    { position: 'Key Accounts Manager' },
    { position: 'Management Accountant' },
    { position: 'Managing Director' },
    { position: 'Operations Intern' },
    { position: 'Operations Manager' },
    { position: 'Principle Key Account Manager' },
    { position: 'PRO & PA to the MD' },
    { position: 'Sales Representative' },
    { position: 'Sales Director' },
    { position: 'Sales Executive' },
    { position: 'Sales Manager' },
    { position: 'Sales Projects & Admin Manger' },
    { position: 'Strategic Planning & Procurement Manger' },
  ]

  allBookingPersons = [
    { firstName: 'Abraham', lastName: 'Shinyunga' },
    { firstName: 'Adeon', lastName: 'Boshoff' },
    { firstName: 'Adolf', lastName: 'de Koe' },
    { firstName: 'Adolf', lastName: 'de Koe' },
    { firstName: 'Adore', lastName: 'Meyer' },
    { firstName: 'Adriaan', lastName: 'de Kok' },
    { firstName: 'Albertina', lastName: 'Koshipyu' },
    { firstName: 'Albertus', lastName: 'Gauaseb' },
    { firstName: 'Alfred', lastName: 'Keja' },
    { firstName: 'Alfred', lastName: 'Loubser' },
    { firstName: 'Altus', lastName: 'Opperman' },
    { firstName: 'Alwyn', lastName: 'Oosthuizen' },
    { firstName: 'Andre', lastName: 'Botha' },
    { firstName: 'Andre', lastName: 'Kruger' },
    { firstName: 'Anfre', lastName: 'Oosthuizen' },
    { firstName: 'Anna', lastName: 'Cloete' },
    { firstName: 'Anton', lastName: 'Nel' },
    { firstName: "Andrea", lastName: "O'Kennedy" },
    { firstName: 'Asnat', lastName: 'Kalenga' },
    { firstName: 'Badison', lastName: 'Boysen' },
    { firstName: 'Bajoroka', lastName: 'Kapuire' },
    { firstName: 'Berdine', lastName: 'Vorster' },
    { firstName: 'Bernice', lastName: 'Dell' },
    { firstName: 'Branden', lastName: 'Cloete' },
    { firstName: 'Chantel', lastName: 'Tap' },
    { firstName: 'Charlene', lastName: 'Karsten' },
    { firstName: 'Charles', lastName: 'Tities' },
    { firstName: 'Christelle', lastName: 'van der Merwe' },
    { firstName: 'Cisley', lastName: 'Rukoro' },
    { firstName: 'Clinton', lastName: 'de Klerk' },
    { firstName: 'Colin', lastName: 'de Beer' },
    { firstName: 'Collin', lastName: 'Gariseb' },
    { firstName: 'Corne', lastName: 'Kasten' },
    { firstName: 'Danica', lastName: 'Enslin' },
    { firstName: 'Daniel', lastName: 'Arries' },
    { firstName: 'Daniel', lastName: 'David' },
    { firstName: 'Daniel', lastName: 'Horaseb' },
    { firstName: 'Daniel', lastName: 'Kapiye' },
    { firstName: 'De Wet', lastName: 'Steyn' },
    { firstName: 'Divan', lastName: 'Opperman' },
    { firstName: 'Dudley', lastName: 'Schultz' },
    { firstName: 'Eduard', lastName: 'Losper' },
    { firstName: 'Eldritch', lastName: 'Fraser' },
    { firstName: 'Elizabeth', lastName: 'Shitana' },
    { firstName: 'Elrette', lastName: 'Carstens' },
    { firstName: 'Eona', lastName: 'Kotze' },
    { firstName: 'Erenst', lastName: 'Tjikusere' },
    { firstName: 'Eva', lastName: 'Adriaans' },
    { firstName: 'Evaristu', lastName: 'Kaisungu (Ndangi)' },
    { firstName: 'Ferial', lastName: 'Ockhuizen' },
    { firstName: 'Fillemon', lastName: 'Amenya' },
    { firstName: 'Franco', lastName: 'Lotter' },
    { firstName: 'Franz', lastName: 'Feris' },
    { firstName: 'Gabriel', lastName: 'Goneb' },
    { firstName: 'Gabriel', lastName: 'Gudde' },
    { firstName: 'Goerge', lastName: 'Walker' },
    { firstName: 'Geraldo', lastName: 'Julie' },
    { firstName: 'Gerdruth', lastName: 'Xoagus' },
    { firstName: 'Gerhard', lastName: 'Suze' },
    { firstName: 'Hans', lastName: 'Neidel' },
    { firstName: 'Hardus', lastName: 'Louwrens' },
    { firstName: 'Hendrieka', lastName: 'Viviers' },
    { firstName: 'Henry', lastName: 'Solomons' },
    { firstName: 'Ian', lastName: 'Stander' },
    { firstName: 'Imanuel', lastName: 'Kudumo' },
    { firstName: 'Ismael', lastName: 'Bachmann' },
    { firstName: 'Izak', lastName: 'van Tonder' },
    { firstName: 'Jaco', lastName: 'Oppernam' },
    { firstName: 'Jan-Gys', lastName: 'Malan' },
    { firstName: 'Jansie', lastName: 'Lourens' },
    { firstName: 'Jasper', lastName: 'van Dyk' },
    { firstName: 'Jeremiah', lastName: 'Gaoab' },
    { firstName: 'Jolandi', lastName: 'de Wet' },
    { firstName: 'Jonas', lastName: 'Shifidi' },
    { firstName: 'Jonty', lastName: 'Jansen van Rensburg' },
    { firstName: 'Joseph', lastName: 'Maani' },
    { firstName: 'Kamwi', lastName: 'Mubusisi' },
    { firstName: 'Kim', lastName: 'Badenhorst' },
    { firstName: 'Lavonna', lastName: 'Kooper' },
    { firstName: 'Lazarus', lastName: 'Auxab (Sporro)' },
    { firstName: 'Lester', lastName: 'Hendricks' },
    { firstName: 'Lincoln', lastName: 'Beukes' },
    { firstName: 'Lourens', lastName: 'Swart' },
    { firstName: 'Louwrens', lastName: 'Louw' },
    { firstName: 'Luke', lastName: 'Pennefather' },
    { firstName: 'Madeleine', lastName: 'Cocklin' },
    { firstName: 'Marius', lastName: 'Rheeder' },
    { firstName: 'Marius', lastName: 'van Niekerk' },
    { firstName: 'Marlien', lastName: 'Nell' },
    { firstName: 'Martha', lastName: 'Hainghumbi' },
    { firstName: 'Martinet', lastName: 'du Plessis' },
    { firstName: 'Max', lastName: 'Ryser' },
    { firstName: 'Mcraven', lastName: 'Januarie' },
    { firstName: 'Mellisa', lastName: 'Eichas' },
    { firstName: 'Menrose', lastName: 'Tjiriange' },
    { firstName: 'Metusalem', lastName: 'Shikongo' },
    { firstName: 'Michael', lastName: 'Durant' },
    { firstName: 'Michelle', lastName: 'Kotze' },
    { firstName: 'Minette', lastName: 'Louw' },
    { firstName: 'Nadia', lastName: 'Minnie' },
    { firstName: 'Nathan', lastName: 'du Preez' },
    { firstName: 'Nico', lastName: 'Vorster' },
    { firstName: 'Olivia', lastName: 'Cloete' },
    { firstName: 'Ovaldine', lastName: 'Namiseb' },
    { firstName: 'Pasteen', lastName: 'Kapuire' },
    { firstName: 'Patric', lastName: 'Kahuure' },
    { firstName: 'Paul-Rize', lastName: 'Jansen' },
    { firstName: 'Paulus', lastName: 'Kaveto' },
    { firstName: 'Peter', lastName: 'Lind' },
    { firstName: 'Petrus', lastName: 'Moonde' },
    { firstName: 'Petrus', lastName: 'Simeon' },
    { firstName: 'Pierre', lastName: 'van Zyl' },
    { firstName: 'Raulinson', lastName: 'Uusizi' },
    { firstName: 'Redcliff', lastName: 'Ndjoze' },
    { firstName: 'Rene', lastName: 'Kruger' },
    { firstName: 'Riaan', lastName: 'Kahavila' },
    { firstName: 'Romano', lastName: 'Booysen' },
    { firstName: 'Rowan', lastName: 'Miller' },
    { firstName: 'Sakeus', lastName: 'Petrus' },
    { firstName: 'Sathy', lastName: 'Thambapilai' },
    { firstName: 'Sean', lastName: 'van der Heuvel' },
    { firstName: 'Shirlene', lastName: 'Brits' },
    { firstName: 'Stephan', lastName: 'Slabbert' },
    { firstName: 'Stephanie', lastName: 'Holden' },
    { firstName: 'Suenett', lastName: 'Tredoux' },
    { firstName: 'Sylvestar', lastName: 'Kasuto' },
    { firstName: 'Tiaan', lastName: 'Bock' },
    { firstName: 'Timo', lastName: 'Amulungu' },
    { firstName: 'Tinus', lastName: 'du Plessis' },
    { firstName: 'Tobias', lastName: 'Mbidhi' },
    { firstName: 'Toivo', lastName: 'Stefanus' },
    { firstName: 'Tommy', lastName: 'Ekandjo' },
    { firstName: 'Verusckha', lastName: 'Lambert' },
    { firstName: 'Victor', lastName: 'Mvula' },
    { firstName: 'Winmar', lastName: 'Rust' },
    { firstName: 'Ynocencia', lastName: 'Goagoses' },
  ];

  filteredBookingPersons = [...this.allBookingPersons];
  searchQuery = '';

  onSearchChange(query: string) {
    this.searchQuery = query.toLowerCase();
    this.filteredBookingPersons = this.allBookingPersons.filter(person => (`${person.firstName} ${person.lastName}`).toLowerCase().includes(this.searchQuery)
    );
  }

  submitBookingRequest(): void {
    if (!this.view.bookingForm.personRequesting) {
      alert('Please select the person requesting the booking.');
      return;
    }

    // Handle your booking logic here
    console.log('Booking submitted:', this.view.bookingForm);

    // Optional: reset the form
    // this.view.bookingForm = { personRequesting: '', ... };
  }


  get currentYear(): number {
    return new Date().getFullYear();
  };

  ngOnInit(): void {
    console.log("Check CIC: ", this.view);
  }
}
